import * as yup from "yup"

export const initialValues = {
  firstName: "",
  lastName: "",
  email: "",
  phoneNumber: "",
  country: "",
  address1: "",
  address2: "",
  city: "",
  stateProvince: "",
  zipCode: "",
  sku: "",
  placeOfPurchase: "",
  purchaseDate: "",
  gearBrand: "",
  gearModel: "",
  gearYear: "",
  recaptcha: "",
}

export default yup.object().shape({
  firstName: yup.string().required("First name is required"),
  lastName: yup.string().required("Last name is required"),
  email: yup.string().email("Invalid email").required("Email is required"),
  phoneNumber: yup.string().required("Phone number is required"),
  country: yup.string().required("Country is required"),
  address1: yup.string().required("Address is required"),
  address2: yup.string(),
  city: yup.string().required("City is required"),
  stateProvince: yup.string().required("State or province is required"),
  zipCode: yup.string().required("Zip Code is required"),
  sku: yup.string().required("Model number (SKU) is required"),
  placeOfPurchase: yup.string().required("Place of purchase is required"),
  purchaseDate: yup.string().required("Purchase date is required"),
  gearBrand: yup.string(),
  gearModel: yup.string(),
  gearYear: yup.string(),
})

export const withRecaptcha = yup.object().shape({
  firstName: yup.string().required("First name is required"),
  lastName: yup.string().required("Last name is required"),
  email: yup.string().email("Invalid email").required("Email is required"),
  phoneNumber: yup.string().required("Phone number is required"),
  country: yup.string().required("Country is required"),
  address1: yup.string().required("Address is required"),
  address2: yup.string(),
  city: yup.string().required("City is required"),
  stateProvince: yup.string().required("State or province is required"),
  zipCode: yup.string().required("Zip Code is required"),
  sku: yup.string().required("Model number (SKU) is required"),
  placeOfPurchase: yup.string().required("Place of purchase is required"),
  purchaseDate: yup.string().required("Purchase date is required"),
  gearBrand: yup.string(),
  gearModel: yup.string(),
  gearYear: yup.string(),
  recaptcha: yup.string().required(),
})
